module.exports = __webpack_public_path__ + "static/group-3-dc14142701618c0a90e2f8f1e00fa75f.svg";